<template>
  <div class="separator-decorated font-ls">
    <span class="text"><slot></slot></span>
  </div>
</template>

<script>
export default {
  name: "Separator"
}
</script>

<style scoped>
.separator-decorated {
  position: relative;
  text-align: center;
}

.separator-decorated::before {
  content: "";
  height: 1px;
  width: 100%;
  background: #ebedf2;
  position: absolute;
  left: 0;
  top: 50%;
}

.separator-decorated > .text {
  background: #fff;
  padding: 0 20px;
  z-index: 1;
  position: relative;
}
</style>
